<template>
  <LbTableActionRow
    class="bids-add-bulk-pricing-table-action-wrapper"
    :show="isAnyItemsSelected"
    :count="selectedKeywords.length"
    @close="clearSelection"
  >
    <div class="bids-add-bulk-pricing-table-action-wrapper__content">
      <ElButton @click="showList">
        {{ $t('ACTION') }}
        <i class="el-icon-arrow-down" />
      </ElButton>

      <ActionPopoverList
        :show="stage === stages.LIST"
        :list="listItems"
        @command="changeStage"
        @hide="closeAll"
      />

      <BidsAddBulkPricingTableActionEdit
        :show="stage === stages.EDIT"
        @hide="closeAll"
        @back="showList"
      />
    </div>
  </LbTableActionRow>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  BULK_IMPORT_DELETE_SELECTED_BIDS,
  BULK_IMPORT_BIDS_SELECTED_KEYWORDS,
} from '@/store/types';

import LbTableActionRow from '../../../../../../common/LbTableActionRow';
import ActionPopoverList from '../../../../../../common/ActionPopoverList';
import BidsAddBulkPricingTableActionEdit from './BidsAddBulkPricingTableActionEdit';

export default {
  name: 'BidsAddBulkPricingTableActionWrapper',
  components: {
    LbTableActionRow,
    ActionPopoverList,
    BidsAddBulkPricingTableActionEdit,
  },
  data() {
    return {
      stage: null,
    };
  },
  computed: {
    ...mapGetters({
      selectedKeywords: BULK_IMPORT_BIDS_SELECTED_KEYWORDS,
    }),
    stages() {
      return {
        LIST: 'list',
        EDIT: 'edit',
        DELETE: 'delete',
      };
    },
    isAnyItemsSelected() {
      return Boolean(this.selectedKeywords.length);
    },
    listItems() {
      return [
        {
          title: this.$t(
            'ADVERTISEMENT.BULK_IMPORT.SPECIFY_SELECTED_PROPERTIES',
          ),
          elIcon: 'el-icon-plus',
          command: this.stages.EDIT,
        },
        {
          title: this.$t('ADVERTISEMENT.BULK_IMPORT.REMOVE_SELECTED_KEYWORDS'),
          elIcon: 'el-icon-delete',
          command: this.stages.DELETE,
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      deleteBidsFromStore: BULK_IMPORT_DELETE_SELECTED_BIDS,
    }),
    closeAll() {
      this.stage = null;
    },
    showList() {
      this.stage = this.stages.LIST;
    },
    changeStage(stage) {
      if (stage === this.stages.DELETE) {
        this.deleteBidsFromStore();
        this.closeAll();
        this.clearSelection();
        return;
      }

      this.stage = stage;
    },
    clearSelection() {
      this.$emit('clearSelection');
    },
  },
};
</script>

<style lang="scss">
.bids-add-bulk-pricing-table-action-wrapper {
  &__content {
    position: relative;
  }
}
</style>
